/**
 * Affichage d'un raccourci clavier déclaré au format `'mod+shift+b'`.
 *
 * @remarks
 * Une seule source pour l'écoute et pour l'affichage : la chaîne `keys` du
 * manifest. Ce module ne fait que la traduire en libellés de touches.
 */

/** `true` sur macOS et iOS, où `mod` désigne Cmd et non Ctrl. */
export function isMacPlatform(): boolean {
  return typeof navigator !== 'undefined' && /mac|iphone|ipad|ipod/i.test(navigator.userAgent);
}

const KEY_LABELS: Record<string, { mac: string; other: string }> = {
  mod: { mac: '⌘', other: 'Ctrl' },
  cmd: { mac: '⌘', other: 'Ctrl' },
  ctrl: { mac: '⌘', other: 'Ctrl' },
  shift: { mac: '⇧', other: 'Shift' },
  alt: { mac: '⌥', other: 'Alt' },
  enter: { mac: '⏎', other: 'Entrée' },
  esc: { mac: 'Esc', other: 'Échap' },
  escape: { mac: 'Esc', other: 'Échap' },
  left: { mac: '←', other: '←' },
  right: { mac: '→', other: '→' },
};

/**
 * Découpe `keys` en libellés de touches, dans l'ordre déclaré.
 *
 * @example
 * formatShortcutKeys('mod+shift+b', false) // ['Ctrl', 'Shift', 'B']
 * formatShortcutKeys('mod+,', true)        // ['⌘', ',']
 */
export function formatShortcutKeys(keys: string, isMac: boolean = isMacPlatform()): string[] {
  return keys
    .split('+')
    .map((part) => part.trim())
    .filter((part) => part !== '')
    .map((part) => {
      const label = KEY_LABELS[part.toLowerCase()];
      if (label !== undefined) return isMac ? label.mac : label.other;
      return part.toUpperCase();
    });
}
